import { OFFERINGS_PATH } from "@constants/routes";
import { SIGN_UP_PAGE_PARAM } from "@stadium/constants/routes";
import { BYSTADIUM_DASHBOARD_HOSTNAME } from "@stadium/helpers/app-routes";

import { featureSwagLocker } from "@stadium/constants/feature-packages";

import builYourOwnBoxImg from "@images/offerings/build-your-own-box.png";
import curatedBoxesImg from "@images/offerings/curated-boxes.png";
import surpriseBoxesImg from "@images/offerings/surprise-boxes.png";
import purchaseSwagImg from "@images/offerings/purchase-swag.png";
import sendExistingSwagImg from "@images/offerings/send-existing-swag.png";

//slugs
export const SHOPS = "shops";
export const BUILD_YOUR_OWN_BOX = "build-your-own-box";
export const THEMED_SNACK_BOXES = "themed-snack-boxes";
export const SWAG_KITS = "swag-kits";
export const SURPRISE_ORDERS = "surprise-orders";
export const SWAG_CATALOG = "swag-catalog";
export const SWAG_LOCKER = "swag-locker";
export const GOODIE_BAGS = "goodie-bags";
export const SNACK_CASES = "snack-cases";
export const GRAB_AND_GO_TRAYS = "grab-and-go-trays";
export const SEND_ITEMS = "send-items";
export const BULK_SWAG = "bulk-swag";
export const OTHER_CHOICES = "other-choices";
export const RECIPIENTS_CHOICE_OFFERINGS = "recipients-pick";
export const SENDERS_CHOICE_OFFERINGS = "senders-pick";
export const OTHER_OFFERINGS = "other";
export const SNACK_BOXES = "snack-boxes";
export const IN_PERSON_SNACKS = "in-person-snacks";
export const SWAG_KITS_CHOICES = "swag-kits-choices";
export const RECOGNITION_PROGRAMS = "recognition-programs";
export const SWAG_STORAGE = "swag-storage";
export const AUTOMATED_GIFTING = "automated-gifting";
export const CURATED_BOXES = "curated-boxes";
export const SURPRISE_BOXES = "surprise-boxes";
export const CREATE_KITS = "create-kits";
export const PURCHASE_AND_DESIGN_SWAG = "purchase-and-design-swag";
export const PURCHASE_SWAG = "purchase-swag";
export const SM_SEND_A_TREAT_ROUTE = "send-a-treat";
export const SM_MENU_ROUTE = "menu";
export const SM_FEATURED_MENU_ROUTE = `${SM_MENU_ROUTE}/featured`;
export const SM_MENU_GOODIE_BAGS_ROUTE = `${SM_MENU_ROUTE}/goodie-bags`;
export const GOODIE_BAGS_MKT_ROUTE = "goodie-bags";
export const ON_DEMAND_SWAG = "on-demand-swag";

//title
export const SHOPS_TITLE = "Company Shops";
export const BUILD_YOUR_OWN_BOX_TITLE = "Build-Your-Own Box";
export const CURATED_BOXES_TITLE = "Curated Boxes";
export const SURPRISE_BOXES_TITLE = "Surprise Boxes";
export const THEMED_SNACK_BOXES_TITLE = "Curated Snack Boxes";
export const SWAG_KITS_TITLE = "Swag (Kits or singles)";
export const SURPRISE_ORDERS_TITLE = "Surprise Orders";
export const SWAG_CATALOG_TITLE = "Request Mockups";
export const SWAG_LOCKER_TITLE = "Swag Locker";
export const GOODIE_BAGS_TITLE = "Goodie Bags";
export const SNACK_CASES_TITLE = "Snack Cases";
export const GRAB_AND_GO_TRAYS_TITLE = "Grab & Go Trays";
export const SEND_ITEMS_TITLE = "Send items to celebrate any moment";
export const BULK_SWAG_TITLE = "Bulk Swag";
export const SNACK_BOXES_TITLE = "Snack Boxes";
export const IN_PERSON_SNACKS_TITLE = "In-Person Snacks & Swag";
export const SWAG_KITS_CHOICES_TITLE = "Swag Kits";
export const RECOGNITION_PROGRAMS_TITLE = "Peer-to-Peer Recognition Programs";
export const SWAG_STORAGE_TITLE = "Swag Storage";
export const AUTOMATED_GIFTING_TITLE = "Automated Gifting";
export const OTHER_CHOICES_TITLE = "Not sure what you need?";
export const PURCHASE_AND_DESIGN_SWAG_TITLE = "Purchase & Design Swag";
export const CREATE_KITS_TITLE = "Create Kits";
export const PURCHASE_SWAG_TITLE = "Purchase Swag";
export const EXISTING_SWAG_TITLE = "Send Existing Swag";
export const RECOGNITION_PROGRAMS_PAGE_TITLE = "Peer-to-Peer Recognition Programs";
export const ON_DEMAND_SWAG_TITLE = "On-Demand Swag";

export const OFFERINGS_CATEGORY_CONTENT_MAPPING = {
  ctaText: "BACK",
  ctaLink: OFFERINGS_PATH,
  heading: "SEND MAGIC THEIR WAY",
  description: "Here are our picks for you",
};

export const OTHER_OFFERINGS_CONTENT_MAPPING = {
  ...OFFERINGS_CATEGORY_CONTENT_MAPPING,
  heading: "THERE’S MORE TO SEE",
  description: "Explore our other offerings",
};

export const OTHER_CHOICES_CONTENT_MAPPING = {
  heading: "LET’S GET STARTED",
  description: "Choose your recipient’s experience",
  ctaText: "BACK",
  ctaLink: "",
};

export const SNACK_BOXES_DATA = {
  [BUILD_YOUR_OWN_BOX]: {
    id: BUILD_YOUR_OWN_BOX,
    title: BUILD_YOUR_OWN_BOX_TITLE,
    description:
      "Send a customizable snack box to anyone, anywhere. It’s every snacker’s dream to have endless options, which is why our diverse menu ensures picks for all.",
    img: builYourOwnBoxImg,
    bgColor: "#ebf4ff",
    videoKey: "offerings-build-your-own",
  },
  [CURATED_BOXES]: {
    id: CURATED_BOXES,
    title: CURATED_BOXES_TITLE,
    description:
      "If you can dream it, we've themed it. Send an expertly curated box to recipients—you choose the theme, from milestones to holidays.",
    img: curatedBoxesImg,
    bgColor: "#ebf4ff",
    videoKey: "offerings-curated-boxes",
  },
  [SURPRISE_BOXES]: {
    id: SURPRISE_BOXES,
    title: SURPRISE_BOXES_TITLE,
    description:
      "Surprises make for the best mail days. Send a themed snack box straight to their door for a sweet surprise (we won't tell!)",
    img: surpriseBoxesImg,
    bgColor: "#ebf4ff",
    videoKey: "offerings-surprise-boxes",
  },
};

const {
  [BUILD_YOUR_OWN_BOX]: BuildYourOwnBox,
  [CURATED_BOXES]: CuratedBoxes,
  [SURPRISE_BOXES]: SurpriseBoxes,
} = SNACK_BOXES_DATA;

export const SNACK_BOXES_OPTIONS = [BuildYourOwnBox, CuratedBoxes, SurpriseBoxes];

export const SWAG_KITS_OPTIONS = [
  {
    key: CREATE_KITS,
    value: CREATE_KITS,
    title: "Yes, I have designed swag",
  },
  {
    key: PURCHASE_AND_DESIGN_SWAG,
    value: PURCHASE_AND_DESIGN_SWAG,
    title: "Not yet, but I'd love to learn more",
  },
];

export const SWAG_STORAGE_DATA = {
  [PURCHASE_SWAG]: (lockerFeUrl) => ({
    id: PURCHASE_SWAG,
    value: PURCHASE_SWAG,
    title: PURCHASE_SWAG_TITLE,
    description:
      "When you want high-quality swag, go straight to the source. Browse our extensive catalog featuring sustainable options, premium brands, and products in all categories.",
    img: purchaseSwagImg,
    bgColor: "#fefaee",
    ctaText: "PURCHASE SWAG",
    ctaLink: lockerFeUrl,
    videoKey: "offerings-purchase-swag",
  }),
  [SWAG_LOCKER]: {
    id: SWAG_LOCKER,
    value: SWAG_LOCKER,
    title: EXISTING_SWAG_TITLE,
    description:
      "No matter where your swag takes you next, we're here. Store your swag with us for an easy way to manage inventory and distribute it for future use.",
    featureSlug: featureSwagLocker,
    img: sendExistingSwagImg,
    bgColor: "#eff9eb",
    ctaLink: `${BYSTADIUM_DASHBOARD_HOSTNAME}/locker/inventory?${SIGN_UP_PAGE_PARAM}`,
    ctaText: "STORE WITH US",
    videoKey: "offerings-swag-locker",
  },
};
